import React, { useState, useEffect } from 'react';
import ListView from '../../components/views/listView';
import { useNavigate } from 'react-router-dom';
import { MasterMessage } from '../../../masters/masterMessages';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ModalBlockPages from './modalBlockPages';
import { HOME } from '../../../routes/paths';
import {
    asyncDeleteBlockPage,
    asyncGetBlockPageId,
    asyncGetBlockPages,
} from '../../../services/blockPages.service';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import EditIcon from '@mui/icons-material/Edit';
import { types } from '../../../redux/types';
import { useDispatch } from 'react-redux';

const ListBlockPages = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [row, setRow] = useState<any>();
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const [open, setOpen] = useState<boolean>(false);
    const [saveLoad, setSaveLoad] = useState<boolean>(false);
    const [idBlockPage, setIdBlockPage] = useState<string>('');
    const [loadingEdit, setLoadingEdit] = useState<boolean>(true);
    const {
        titleList,
        titleDelete,
        messageDelete,
        messageDeleteOk,
        messageDeleteError,
    } = MasterMessage.blokPages;

    useEffect(() => {
        if (saveLoad && page !== 0) {
            setPage(0);
            setSaveLoad(false);
            return;
        } else if (saveLoad) setSaveLoad(false);

        asyncGetBlockPages(page, pageSize)
            .then((body: any) => {
                if (body.items !== undefined) {
                    setRows(body.items.items);
                    setLengthRows(body.items.length);
                    dispatch({
                        type: types.blockPages,
                        payload: body.items.items,
                    });
                }
            })
            .finally(() => setLoading(false));

        if (idBlockPage) {
            setLoadingEdit(true);
            asyncGetBlockPageId(idBlockPage).then((body: any) => {
                if (body.items !== undefined) {
                    setRow(body.items);
                }
            });
            window.setTimeout(() => {
                setLoadingEdit(false);
            }, 1000);
        }
    }, [page, pageSize, saveLoad, idBlockPage]);

    const onEditClick = (row: any) => {
        setIdBlockPage(row.id);
        setOpen(true);
    };

    const onCloseClick = (value: boolean) => {
        setIdBlockPage('');
        setRow(undefined);
        setOpen(value);
    };

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const deleteBlockPage = (row: any) => {
        Swal.fire({
            title: titleDelete,
            text: messageDelete,
            icon: 'error',
            iconColor: '#1d1d1d',
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: '#1d1d1d',
            confirmButtonText: 'SI',
            confirmButtonColor: '#1d1d1d',
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteBlockPage(row.id).then((body: any) => {
                    if (body.items !== undefined) {
                        SwalCustomClass.fire({
                            text: messageDeleteOk,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                        });
                        asyncGetBlockPages(page, pageSize).then((body: any) => {
                            if (body.items !== undefined) {
                                setRows(body.items.items);
                                setLengthRows(body.items.length);
                                dispatch({
                                    type: types.blockPages,
                                    payload: body.items.items,
                                });
                            }
                        });
                    } else {
                        SwalCustomClass.fire({
                            text: messageDeleteError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                        });
                    }
                });
            }
        });
    };

    const columns = [
        {
            field: 'page',
            headerName: 'Página Bloqueada',
            minWidth: 120,
            flex: 1,
        },
        {
            field: 'description',
            headerName: 'Descripción',
            minWidth: 150,
            flex: 1,
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title="Editar">
                        <IconButton
                            size="small"
                            onClick={() => onEditClick(row)}
                        >
                            <EditIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <IconButton
                            size="small"
                            onClick={() => deleteBlockPage(row)}
                        >
                            <DeleteIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <>
            <ListView
                title={titleList}
                titleButtonAdd={'Agregar'}
                startIconButtonAdd={<AddCircleIcon color="secondary" />}
                onClickAdd={() => setOpen(true)}
                onClickBack={() => navigate(HOME)}
                columns={columns}
                rows={rows}
                rowCount={lengthRows}
                disableRow={true}
                loading={loading}
                onSetPage={(paginationModel: any) => paginator(paginationModel)}
            />
            {open && (
                <ModalBlockPages
                    open={open}
                    onClose={(value: boolean) => onCloseClick(value)}
                    saveLoad={(value: boolean) => setSaveLoad(value)}
                    idBlockPage={idBlockPage}
                    blockPage={row}
                    loading={idBlockPage ? loadingEdit : false}
                />
            )}
        </>
    );
};

export default ListBlockPages;
